import {mapMutations} from 'vuex';
export default {
    methods:{
        onReturn(){
            this.$router.replace('/');
        },
        ...mapMutations({
            logout: 'auth/logout',
        }),
    }
}
